var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-radio-group",
        {
          on: { change: _vm.change },
          model: {
            value: _vm.$store.state.user.projectCode,
            callback: function ($$v) {
              _vm.$set(_vm.$store.state.user, "projectCode", $$v)
            },
            expression: "$store.state.user.projectCode",
          },
        },
        _vm._l(_vm.projectList, function (item) {
          return _c(
            "el-radio-button",
            { key: item.value, attrs: { label: item.value } },
            [_vm._v(_vm._s(item.label))]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }